/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import { createRef, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card, CardContent, CardDescription } from "@repo/ui";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { MdUpdate } from "react-icons/md";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { PATHS } from "routes/paths";
import { useExportCalls, useGetAssignedCalls } from "services/tickets";
import Loader from "ui/page-loader";
import { BreadCrumb } from "ui/bread-crumbs";
import { FiltersContext } from "store/filters-context";
import UpdateStatus from "./update-status";
import { StatusContext } from "../constants";
import {
  fixKendoGridContent,
  getCurrentTicketScreen,
  isFilterUpdated,
} from "../utils";
import FilterBarV2 from "../common/filter-bar";
import GridDataCopyCell from "components/copy";

export default function CCAAssignedCallsList() {
  const [dataState, setDataState] = useState({
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ],
  });
  const [tickets, setTickets] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [reload, setReload] = useState(false);
  const { filters } = useContext(FiltersContext);
  const [localFilters, setLocalFilters] = useState({
    searchCriteria: filters?.searchCriteria?.value || "",
    period: filters?.period?.value || "All",
    cashCenterId: filters?.cashCenterId?.value || "",
    customerId: filters?.customerId?.value || "",
    assetId: filters?.assetId?.value || "",
    activityType: filters?.activityType?.value || "",
    assignmentGroup: filters?.assignmentGroup?.value || "",
  });
  const { setStatus } = useContext(StatusContext);

  const pageSize = 100;
  const _exporter = createRef();

  useEffect(() => {
    const nextFilters = {
      searchCriteria: filters?.searchCriteria?.value || "",
      period: filters?.period?.value || "All",
      cashCenterId: filters?.cashCenterId?.value || "",
      customerId: filters?.customerId?.value || "",
      assetId: filters?.assetId?.value || "",
      activityType: filters?.activityType?.value || "",
      assignmentGroup: filters?.assignmentGroup?.value || "",
    };

    if (isFilterUpdated(localFilters, nextFilters)) {
      setLocalFilters({ ...nextFilters });
    }
  }, [filters]);
  const {
    mutate: getTickets,
    data: ticketsList,
    isPending: gettingTickets,
    reset: resetGetTickets,
  } = useGetAssignedCalls();

  const {
    mutate: getAllTickets,
    data: allTicketsData,
    isPending: gettingAllTickets,
    reset: getAllTicketsReset,
  } = useExportCalls();

  useEffect(() => {
    if (allTicketsData) {
      excelExport();
      getAllTicketsReset();
    }
  }, [allTicketsData]);

  useEffect(() => {
    setCurrentPage(1);
    getTickets({
      pageNumber: 1,
      pageRowCount: pageSize,
      ...localFilters,
    });
  }, [reload, localFilters]);

  useEffect(() => {
    if (ticketsList) {
      setTotalRecords(ticketsList.data.totalRecords);
      setTickets(
        ticketsList.data.data.map((elm) => ({
          ...elm,
          vaultAccessRequired: elm.vaultAccessRequired ? "Yes" : "No",
          vaultAccessAdded: elm.vaultAccessAdded ? "Yes" : "No",
        }))
      );
      resetGetTickets();
    }
  }, [ticketsList]);

  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getTickets({
      pageNumber: _page,
      pageRowCount: pageSize,
      ...localFilters,
    });
  };

  const onRefresh = () => {
    getTickets({
      pageNumber: currentPage,
      pageRowCount: pageSize,
      ...localFilters,
    });
  };
  const updateCell = ({ dataItem }) => {
    return (
      <td>
        <div
          className="flex items-center justify-center w-full"
          title="Update Status"
        >
          <UpdateStatus
            triggerButton={
              <Button variant="outline">
                <MdUpdate
                  fontSize="18px"
                  className="text-primary font-[18px]"
                />
              </Button>
            }
            onReload={() => {
              setReload(!reload);
            }}
            requestDetails={dataItem}
          />
        </div>
      </td>
    );
  };

  const excelExport = () => {
    if (_exporter.current) {
      _exporter.current.save();
    }
  };

  return (
    <div className="box-border">
      {gettingTickets ? <Loader /> : <></>}
      <BreadCrumb
        className="mx-4"
        items={[
          { text: "CCA Calls", to: PATHS.allCalls },
          { text: "Assigned Calls" },
        ]}
      />
      <Card className="mx-4 mt-5">
        <CardContent>
          <CardDescription className="pt-6">
            <FilterBarV2
              exportExcel
              onRefresh={onRefresh}
              exportingExcel={gettingAllTickets}
              hideStatus
              onExcelExport={() => {
                getAllTickets({
                  status: "Assigned",
                  ...localFilters,
                });
              }}
            />
          </CardDescription>

          <Grid
            data={process(
              tickets.map((item) => ({
                ...item,
              })),
              dataState
            )}
            {...dataState}
            filterable
            className="list-tables-v1"
            width="100%"
            sortable
            pageable
            navigatable
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
            onDataStateChange={(e) => {
              setDataState(e.dataState);
            }}
            ref={(e) => {
              fixKendoGridContent(e);
            }}
          >
            <GridColumn
              title="Update"
              filterable={false}
              cell={updateCell}
              width="100px"
            />
            <GridColumn
              title="Open At"
              field="createDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn
              title="Resolve At"
              field="resolvedDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn
              title="State"
              field="status"
              width="150px"
              className="text-center"
              headerClassName="text-center"
              filterable
            />
            <GridColumn title="Account" field="customer" width="170px" />
            <GridColumn title="Asset Id" field="locationId" width="150px" />
            <GridColumn
              title="Ticket Number"
              width="170px"
              field="caseNo"
              cell={(items) => {
                const dataItem = items.dataItem;
                return (
                  <GridDataCopyCell
                    dataItem={items.dataItem}
                    field={items.field}
                    customCell={
                      <td>
                        <Link
                          onClick={() => {
                            setStatus("assigned");
                          }}
                          to={getCurrentTicketScreen(dataItem)}
                        >
                          {dataItem.status === "Draft"
                            ? "View Draft"
                            : dataItem.caseNo}
                        </Link>
                      </td>
                    }
                  />
                );
              }}
            />

            <GridColumn
              title="Bank Reference/Address"
              field="customerTicketNo"
              width="200px"
            />
            <GridColumn
              title="Activity Type"
              field="activityType"
              width="170px"
            />
            <GridColumn title="Category" field="category" width="150px" />
            <GridColumn
              title="Sub Category"
              field="subCategory"
              width="150px"
            />
            <GridColumn title="Location" field="locationName" width="170px" />
            <GridColumn title="Region" field="region" width="150px" />
            <GridColumn
              title="Assignment Group"
              field="assignmentGroup"
              width="170px"
            />

            <GridColumn title="Reported By" field="reportedBy" width="170px" />
            <GridColumn title="Description" field="remarks" width="400px" />
            <GridColumn
              title="Resolution Notes"
              field="resolutionNotes"
              width="170px"
            />
          </Grid>
          <ExcelExport
            data={allTicketsData?.data.data || []}
            fileName="Assigned_Tickets.xlsx"
            ref={_exporter}
          >
            <GridColumn
              title="Created At"
              field="createDateTime"
              width="170px"
            />
            <GridColumn title="State" field="status" width="200px" />
            <GridColumn title="Account" field="customer" width="170px" />
            <GridColumn title="Asset Id" field="locationId" width="150px" />
            <GridColumn title="Ticket Number" width="170px" field="caseNo" />

            <GridColumn
              title="Bank Reference/Address"
              field="customerTicketNo"
            />
            <GridColumn
              title="Activity Type"
              field="activityType"
              width="170px"
            />
            <GridColumn title="Category" field="category" width="150px" />
            <GridColumn
              title="Sub Category"
              field="subCategory"
              width="150px"
            />
            <GridColumn title="Location" field="locationName" width="170px" />
            <GridColumn title="Region" field="region" width="150px" />
            <GridColumn
              title="Assignment Group"
              field="assignmentGroup"
              width="170px"
            />
            <GridColumn title="Reported By" field="reportedBy" width="170px" />
            <GridColumn title="Description" field="remarks" width="170px" />
            <GridColumn
              title="Resolution Notes"
              field="resolutionNotes"
              width="170px"
            />

            <GridColumn title="Opened By" field="openedBy" width="170px" />
          </ExcelExport>
        </CardContent>
      </Card>
    </div>
  );
}
